// TODO(WEB): Refactor away from react-native-network-logger / maybe leave blank shim

import React from 'react'
import { View } from 'react-native'
export const startNetworkLogging = () => {}
export const NetworkLogger = () => <View></View>
export default NetworkLogger
